export default __webpack_public_path__ + "static/media/chainshot.bd10d6ca.png";